import { Stepper } from "@homebound/beam";
import { useStepperContext } from "src/components/stepper/StepperContext";

export function StepperContextStepper() {
  const { steps, currentStep, goToStep } = useStepperContext();
  return <Stepper steps={steps} currentStep={currentStep.value} onChange={goToStep} />;
}
